/**
 * @generated SignedSource<<3b07d8b67c4d7a5e4a648f6e2e0d90dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbleDesignManager_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TradeDesignManagerModal_item" | "TradeOnboardingCoachmarkConditionalLoader_item">;
  readonly " $fragmentType": "PdpRespIconBubbleDesignManager_item";
};
export type PdpRespIconBubbleDesignManager_item$key = {
  readonly " $data"?: PdpRespIconBubbleDesignManager_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleDesignManager_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbleDesignManager_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeOnboardingCoachmarkConditionalLoader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeDesignManagerModal_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6a6322d9f0824039950e04855d26b3d9";

export default node;
